import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { pick } from 'lodash';

import { navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';
import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import { GanttChart } from '../../common/GanttChart';

import styles from './ImplementationPlanSection.module.scss';

export const ImplementationPlanSection: React.FC = () => {
  const {
    data: { implementationPlanStages },
  } = useDataContext();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.implementationPlan);

  if (!implementationPlanStages) {
    return null;
  }

  const sectionData = pick(implementationPlanStages[0], ['from', 'to', 'stage']);

  if (!hasMeaningfulValues(sectionData)) {
    return null;
  }

  return (
    <Box {...registerNavSection} className={styles.section}>
      <Box className={styles.wrapper}>
        <Box className={styles.title}>{t('chapters.IMPLEMENTATION_PLAN')}</Box>
        <GanttChart
          data={implementationPlanStages}
          MobileCardWrapper={({ children }) => <Box className={styles.chartContainer}>{children}</Box>}
          variant={STYLE_VARIANTS.OUTLINED}
        />
      </Box>
    </Box>
  );
};
